"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilIconAdd = void 0;
var react_1 = __importDefault(require("react"));
var IconBase_1 = __importDefault(require("../IconBase"));
var utils_1 = require("../utils");
var ActionAdd = function (props) { return (react_1.default.createElement(IconBase_1.default, __assign({}, props),
    react_1.default.createElement("path", { d: "M10.4002 10.3998V3.99981C10.4002 3.11981 11.1202 2.39981 12.0002 2.39981C12.8802 2.39981 13.6002 3.11981 13.6002 3.99981V10.3998H20.0002C20.8802 10.3998 21.6002 11.1198 21.6002 11.9998C21.6002 12.8798 20.8802 13.5998 20.0002 13.5998H13.6002V19.9998C13.6002 20.8798 12.8802 21.5998 12.0002 21.5998C11.1202 21.5998 10.4002 20.8798 10.4002 19.9998V13.5998H4.00021C3.12021 13.5998 2.40021 12.8798 2.40021 11.9998C2.40021 11.1198 3.12021 10.3998 4.00021 10.3998H10.4002Z" }))); };
exports.UtilIconAdd = (0, utils_1.withDeprecationWarning)(ActionAdd, 'UtilIconAdd');
exports.default = ActionAdd;
